function generate(type = 'V') {
    return `${type || ''}${Math.random().toString(36).substring(2)}${Math.random().toString(36).substring(2)}`.substring(0, 13).toUpperCase()
}

export default {
    generate
}
